import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ClerkProvider } from '@clerk/clerk-react';
import { HelmetProvider } from 'react-helmet-async';
import { clerkConfig } from './config/clerk';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { createLogger } from './utils/logger';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _bootstrapLogger = createLogger('bootstrap');

const rootElement = document.getElementById('root') as HTMLElement;

const appContent = (
  <React.StrictMode>
    <HelmetProvider>
      <ClerkProvider {...clerkConfig}>
        <App />
      </ClerkProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// Only hydrate when react-snap has pre-rendered (it adds data-reactroot).
// The static SEO content in index.html is NOT React-rendered, so always use createRoot for it.
const isPrerendered = rootElement.hasAttribute('data-reactroot');

if (isPrerendered) {
  ReactDOM.hydrateRoot(rootElement, appContent);
} else {
  ReactDOM.createRoot(rootElement).render(appContent);
}

// Unregister service worker to clear cache during development
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a logging callback
// to reportWebVitals or send the metrics to an analytics endpoint.
reportWebVitals();
